import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";
import {
  BrandList, DeleteBrand, BrandChangeStatus,
} from "../../../redux/services/BrandService/brand.Services";
import Pagination from "../../../common/Pagination";
import Swal from "sweetalert2";
function AllBrandList() {
  const dispatch = useDispatch();
  const [brands, setBrands] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [imageUrl, setImageUrl] = useState("");
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const refreshData = useSelector(
    (state) => state.productModal.refreshData
  );
  const [loading, setLoading] = useState(false);
  const fetchBrands = async () => {
    try {
      setLoading(true);
      const payload = {
        page,
        search,
        status,
      };
      const res = await BrandList(payload);
      setBrands(res?.data || []);
      setLastPage(res?.last_page || 1);
      setImageUrl(res?.image_url);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBrands();
  }, [page, search, status, refreshData]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };
  return (
    <div>
      <div className="d-md-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="page-header">
          <div>
            <h3 className="page-title">Brand List</h3>
            <nav className="page-breadcrumb">
              <Link to="/">Home</Link>
              <span className="mx-2">/</span>
              <span>All Brand </span>
            </nav>
          </div>
        </div>
        <button
          className="add-btn"
          onClick={() =>
            dispatch(
              openProductModal({
                type: "create-brand",
                title: "Create Brand",
                data: {
                  refreshData: fetchBrands,
                },
              })
            )
          }
        >
          + Add Brand
        </button>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Name..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Name</th>
                  <th>Image</th>
                  {/* <th>Status</th> */}
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {brands.length > 0 ? (
                  brands.map((item, index) => (
                    <tr key={item.id}>
                        <td> {(page - 1) * limit + index + 1}</td>
                      <td>{item.name}</td>
                      <td>
                        <img
                          src={
                            item.logo
                              ? `${process.env.REACT_APP_IMAGE_URL}${imageUrl}/${item.logo}`
                              : "/placeholder-image.png"
                          }
                          alt={item.name}
                          width="40"
                          height="40"
                          // className="img-thumbnail"
                        />
                      </td>
                      {/* <td>{item.status === 1 ? "Active" : "Inactive"}</td> */}
                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item._id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status: item.status ? "Active" : "Inactive",
                                    statusFunction: BrandChangeStatus,
                                    onSuccess: fetchBrands,
                                  },
                                })
                              )
                            }
                          />

                          <label
                            htmlFor={`status-${item._id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>

                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>

                        </div>
                      </td>



                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "view-brand",
                                  title: "View Brand",
                                  data: { ...item, imageUrl }
                                })
                              )
                            }
                          >
                            <FaEye />
                          </button>

                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "edit-brand",
                                  title: "Edit Brand",
                                  data: {
                                    ...item,
                                    refreshData: fetchBrands,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-brand",
                                  title: "Delete Brand",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteBrand,
                                    refreshData: fetchBrands,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllBrandList;